import { type AnalyticsManager } from "services/analytics/analyticsManager";
import type { CompanyAbnQuestionsStore } from "services/questions/au/abn/companyAbnQuestionsStore";
import type { DirectorAbnQuestionsStore } from "services/questions/au/abn/directorAbnQuestionsStore";
import type { IdentityQuestionsStore } from "services/questions/au/identityQuestionsStore";
import { RegisterFormStep } from "services/registerForm/registerFormStep";
import { RegisterFormSteps } from "services/registerForm/registerFormSteps";
import { RegisterFormStepsStoreBase } from "services/registerForm/registerFormStepsStoreBase";
import { AbnFormStep } from "./constants";

export class AbnRegisterFormStepsStore extends RegisterFormStepsStoreBase<AbnFormStep> {
  protected readonly _steps: RegisterFormSteps<AbnFormStep> = new RegisterFormSteps<AbnFormStep>([
    new RegisterFormStep(AbnFormStep.FLOW_SELECT, "Select the option"),
    new RegisterFormStep(AbnFormStep.CONSENT, "Before you get started"),
    new RegisterFormStep(AbnFormStep.COMPANY, "Company details", this._companyQuestionsStore),
    new RegisterFormStep(AbnFormStep.DIRECTOR, "Business associates", this._directorAbnQuestionsStore),
    new RegisterFormStep(AbnFormStep.IDENTITY, "Confirm identity", this._identityQuestionsStore),
    new RegisterFormStep(AbnFormStep.CONFIRM, "Confirm and submit"),
    new RegisterFormStep(AbnFormStep.COMPLETE, "Complete"),
  ]);
  readonly confirmStep: AbnFormStep = AbnFormStep.CONFIRM;
  readonly completeStep: AbnFormStep = AbnFormStep.COMPLETE;

  constructor(
    private readonly _companyQuestionsStore: CompanyAbnQuestionsStore,
    private readonly _directorAbnQuestionsStore: DirectorAbnQuestionsStore,
    private readonly _identityQuestionsStore: IdentityQuestionsStore,
    protected readonly _analyticsManager: AnalyticsManager,
  ) {
    super(_analyticsManager);
  }
}
